import * as moment from 'moment/moment';
import {
  KpiFooterStats,
  KpiStatus,
  KpiStatusType,
  KpiTitle,
  KpiVM,
} from 'src/app/dashboards/dashboard-shared/kpi/kpi-stats/kpi-view-model';
import { Kpi, KpiMetric, KpiStat } from 'src/app/shared/flight-log-api/kpi/kpi.model';

export class NightLandingKpis {
  public static create(kpiMetric: KpiMetric) {
    return new NightLandingKpis(kpiMetric);
  }
  constructor(private kpiMetric: KpiMetric) {}

  public createKpi(granularity: string, windowSize: number) {
    return (): KpiVM | undefined => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const kpi: Kpi = this.getKpi(granularity, windowSize)!;
      switch (granularity + windowSize) {
        case 'Day90': {
          return this.applyRule(this.kpiMetric, kpi);
        }
      }
    };
  }

  private applyRule(kpiMetric: KpiMetric, kpi: Kpi): KpiVM {
    const currentStat = this.getCurrentKpiStat(kpi);
    // default to ok
    let status = KpiStatus.ok;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (currentStat.value < kpi.minimum!) {
      status = KpiStatus.danger;
    }
    return this.createKpiVm(kpiMetric, kpi, currentStat, status);
  }

  private getKpi(granularity: string, windowSize: number) {
    return this.kpiMetric.kpis.find(
      (kpi) => kpi.granularity === granularity && kpi.windowSize === windowSize,
    );
  }

  private getCurrentKpiStat(kpi: Kpi): KpiStat {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return kpi.data.find((stat) => stat.isCurrentPeriod != null && stat.isCurrentPeriod)!;
  }

  private getFutureKpiStat(kpi: Kpi): KpiStat {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return kpi.data.find((stat) => stat.isFuturePeriod != null && stat.isFuturePeriod)!;
  }

  private createKpiVm(
    kpiMetric: KpiMetric,
    kpi: Kpi,
    currentStat: KpiStat,
    status: KpiStatusType,
  ): KpiVM {
    const futureStat = this.getFutureKpiStat(kpi);
    const expiringValue = futureStat != null ? currentStat.value - futureStat.value : 0;
    const expiringText =
      futureStat != null ? `expiring ${moment(futureStat.timestamp).format('M/YYYY')}` : 'expiring';
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const stayCurrentValue = futureStat != null ? Math.abs(futureStat.kpiBreachAmount!) : 0;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const progress = Math.floor((currentStat.value / kpi.minimum!) * 100);

    return new KpiVM(
      KpiTitle.create(`${kpi.windowSize} ${kpi.granularity}`, `${kpiMetric.name}`),
      `${currentStat.value} of ${kpi.minimum}`,
      {
        stat1: KpiFooterStats.create(`${expiringValue}`, expiringText),
        stat2: KpiFooterStats.create(`${stayCurrentValue}`, ' more to stay current'),
      },
      status,
      progress > 100 ? 100 : progress,
    );
  }
}
